import { useTranslation } from 'react-i18next'
import type { MeetingManagementTask } from '../types'

/**
 * Görevin kaynağı işareti (105, kullanıcı isteği 2026-11-02) — ana görevde ikon görünümlü bir harf
 * (dolu zemin, beyaz harf; iki tür aynı zemindedir, yalnız harfle ayrılır): **D** = Doğrudan Görev
 * (toplantıya bağlı değil),
 * **T** = Toplantı Bağımlı Görev. Üzerine gelince tam adı yazar. Tablo ve kart dalının **ortak**
 * bileşenidir ({@link AttachmentCell} gibi), iki görünüm ayrışamaz.
 *
 * <p>Ölçüt sunucudan gelen {@code directTask}'tır; istemci toplantı bilgisi taşımaz ve hesap yapmaz.
 * <b>Alt görev satırında hiçbir şey çizilmez</b>: sunucu orada {@code directTask}'ı daima
 * {@code false} verir ve bu "toplantı bağımlı" demek DEĞİLDİR (doğrudan görevin alt görevi de
 * toplantısızdır) — alt görev, işaretli ana görevin hemen altında durur.
 *
 * <p>Harf ekran okuyucudan gizlenir, yerine tam ad {@code ui-sr-only} ile okunur: tek harf ("D")
 * ekran okuyucu kullanıcısına bir şey söylemez ({@code ResponsibleGroups}'taki {@code title} +
 * gizli metin kalıbı).
 */
export default function TaskOriginMark({ row }: Readonly<{ row: MeetingManagementTask }>) {
  const { t } = useTranslation()
  // Alan yanıtta yoksa (eski arka uç) işaret yok: `undefined` "T" sayılırsa doğrudan görev yanlış
  // etiketlenir — yanlış bilgi, eksik bilgiden kötüdür (bkz. `MeetingManagementTask.directTask`).
  if (row.subTask || row.directTask === undefined) {
    return null
  }
  const label = row.directTask
    ? t('meetingManagement.origin.direct')
    : t('meetingManagement.origin.meetingBound')
  const letter = row.directTask
    ? t('meetingManagement.origin.directShort')
    : t('meetingManagement.origin.meetingBoundShort')
  return (
    <span className="mm-origin-mark" title={label}>
      <span className="mm-origin-letter" aria-hidden="true">
        {letter}
      </span>
      <span className="ui-sr-only">{label}</span>
    </span>
  )
}
